











import { Component, Vue, Watch } from "vue-property-decorator";
import { ConfigModule } from "@/store/index";

@Component({})
export default class Terms extends Vue {
  /* -------------- data ------------- */
  termTitleKey = "";
  termContentKey = "";

  backButtonTitle = ""; // 返回按钮文本

  /* -------------- watch ------------- */
  @Watch("lang")
  async onChangeLang (val: string, oldVal: string) {
    if (oldVal) {
      // 获取网站资源
      this.initAssets();
    }
  }

  @Watch("$route")
  onChangeRoute () {
    this.termTitleKey = this.$route.meta.termTitleKey;
    this.termContentKey = this.$route.meta.termContentKey;
  }

  /* -------------- computed ------------- */
  get lang () {
    // 语言key值
    return ConfigModule.lang;
  }

  get categoryForUserTermTitle () {
    // 用户条款标题
    return ConfigModule.categoryForUserTermTitle;
  }

  get categoryForUserTermContent () {
    // 用户条款内容
    return ConfigModule.categoryForUserTermContent;
  }

  get categoryForPrivacyTermTitle () {
    // 隐私策略标题
    return ConfigModule.categoryForPrivacyTermTitle;
  }

  get categoryForPrivacyTermContent () {
    // 隐私策略内容
    return ConfigModule.categoryForPrivacyTermContent;
  }

  get categoryForAgreementTitle () {
    // 用户同意条款标题
    return ConfigModule.categoryForAgreementTitle;
  }

  get categoryForAgreementContent () {
    // 用户同意条款标题
    return ConfigModule.categoryForAgreementContent;
  }

  get categoryForContactEmailTitle () {
    // 联系邮箱标题
    return ConfigModule.categoryForContactEmailTitle;
  }

  get categoryForContactEmailContent () {
    // 联系邮箱地址
    return ConfigModule.categoryForContactEmailContent;
  }

  get termTitle () {
    return (this as Record<string, any>)[this.termTitleKey];    // eslint-disable-line
  }

  get termContent () {
    return (this as Record<string, any>)[this.termContentKey];    // eslint-disable-line
  }

  /* -------------- hook ------------- */
  async created () {
    await this.initAssets();
  }

  /* -------------- methods ------------- */

  /**
   * @description: 初始化页面资源
   */

  async initAssets () {
    try {
      const getSiteAssetsRet = await ConfigModule.getSiteAssets(this.lang);
      this.termTitleKey = this.$route.meta.termTitleKey;
      this.termContentKey = this.$route.meta.termContentKey;

      const siteAssets = getSiteAssetsRet.payload.siteAssets.data.asset;
      this.backButtonTitle = siteAssets.categoryForBackTitle;
    } catch (error) {
      console.log(error);
    }
  }
}
